import React, { forwardRef, HTMLAttributes } from 'react';
import Utils from '../../../utils/Utils';

type HomeCardVariant = 'compact' | 'wide' | 'spacious';

const variantClasses: Record<HomeCardVariant, string> = {
  compact: '!w-[317px] h-[265px] p-3 gap-3',
  wide: 'w-[576px] h-[277px] p-5 gap-3',
  spacious: 'w-[576px] h-[283px] p-5 gap-5',
};

type HomeCardProps = HTMLAttributes<HTMLDivElement> & {
  variant?: HomeCardVariant;
};

export const HomeCard = forwardRef<HTMLDivElement, HomeCardProps>(
  ({ variant = 'compact', className, style, children, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={Utils.cn(
          'flex flex-col border border-solid border-gray-200 rounded-[20px] bg-home-card-bg text-gray-900 shadow-shadow-xs',
          variantClasses[variant],
          className,
        )}
        style={{
          WebkitBackdropFilter: 'blur(4px)',
          backdropFilter: 'blur(4px)',
          ...style,
        }}
        {...props}>
        {children}
      </div>
    );
  },
);
HomeCard.displayName = 'HomeCard';
